import * as moment from 'moment';

import {
    AdjustmentCategoryEnum,
    PaymentFilterModel,
    PaymentMethodsEnum,
    PaymentProcessesEnum,
    PaymentPurchaseTypeEnum,
    PaymentReportModel,
    PaymentStatusesEnum
} from '@spa/api';

import {ComponentTypesEnum, FeatureEnum} from '../../app/shared/enums';
import {FilterControlInterface} from '../../app/shared/interfaces';
import {
    DialogButtonTypesEnum,
    DialogConfigInterface,
    ReportTableColumn,
    ReportTableConfigInterface,
    ReportTableData
} from '../../app/shared/components';
import {AmountControl, BaseControl, DatepickerControl, Helper, SelectControl} from '../../app/shared/classes';

export const PanelPaymentsRequestIdSelector = 'id';
export const PanelPaymentsFilterAmountSelector = 'filterAmount';
export const PanelPaymentsFilterDateSelector = 'filterDate';
export const PanelPaymentsFilterTradingPlanReferenceIdSelector = 'tradingPlanReferenceId';
export const PanelPaymentsFilterPurchaseTypeIdSelector = 'purchaseTypeId';
export const PanelPaymentsFilterSettledDateSelector = 'filterSettledDate';
export const MaxPaymentAmount = 1000000; 
export const PanelPaymentsStorageId = 'PanelPaymentsComponent';
export const PanelClientsEditPaymentsStorageId = 'PanelClientsEditPaymentsComponent';

export const PanelPaymentsFilterControls = (): FilterControlInterface[] => {
    const controls = [
        {
            name: PaymentFilterModel.getPaymentStatusSelector(),
            placeholder: 'Status',
            controls: [
                new SelectControl({
                    name: PaymentFilterModel.getPaymentStatusSelector(),
                    value: PaymentStatusesEnum.All,
                    placeholder: 'Status',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: Helper.textsHelper().getPaymentStatusName(PaymentStatusesEnum.All),
                            value: PaymentStatusesEnum.All
                        },
                        {
                            label: Helper.textsHelper().getPaymentStatusName(PaymentStatusesEnum.New),
                            value: PaymentStatusesEnum.New
                        },
                        {
                            label: Helper.textsHelper().getPaymentStatusName(PaymentStatusesEnum.ForApproval),
                            value: PaymentStatusesEnum.ForApproval
                        },
                        {
                            label: Helper.textsHelper().getPaymentStatusName(PaymentStatusesEnum.OnHold),
                            value: PaymentStatusesEnum.OnHold
                        },
                        {
                            label: Helper.textsHelper().getPaymentStatusName(PaymentStatusesEnum.Pending),
                            value: PaymentStatusesEnum.Pending
                        },
                        {
                            label: Helper.textsHelper().getPaymentStatusName(PaymentStatusesEnum.Rejected),
                            value: PaymentStatusesEnum.Rejected
                        },
                        {
                            label: Helper.textsHelper().getPaymentStatusName(PaymentStatusesEnum.Processed),
                            value: PaymentStatusesEnum.Processed
                        },
                        {
                            label: Helper.textsHelper().getPaymentStatusName(PaymentStatusesEnum.Canceled),
                            value: PaymentStatusesEnum.Canceled
                        },
                        {
                            label: Helper.textsHelper().getPaymentStatusName(PaymentStatusesEnum.Approved),
                            value: PaymentStatusesEnum.Approved
                        },
                        {
                            label: Helper.textsHelper().getPaymentStatusName(PaymentStatusesEnum.CanceledByClient),
                            value: PaymentStatusesEnum.CanceledByClient
                        },
                        {
                            label: Helper.textsHelper().getPaymentStatusName(PaymentStatusesEnum.Completed),
                            value: PaymentStatusesEnum.Completed
                        },
                        {
                            label: Helper.textsHelper().getPaymentStatusName(PaymentStatusesEnum.ApprovedByOperator),
                            value: PaymentStatusesEnum.ApprovedByOperator
                        },
                        {
                            label: Helper.textsHelper().getPaymentStatusName(PaymentStatusesEnum.Processing),
                            value: PaymentStatusesEnum.Processing
                        },
                        {
                            label: Helper.textsHelper().getPaymentStatusName(PaymentStatusesEnum.Deleted),
                            value: PaymentStatusesEnum.Deleted
                        },
                    ]
                })
            ],
            sortIndex: 1
        },
        {
            name: PaymentFilterModel.getPaymentProcessSelector(),
            placeholder: 'Type',
            controls: [
                new SelectControl({
                    name: PaymentFilterModel.getPaymentProcessSelector(),
                    value: PaymentProcessesEnum.All,
                    placeholder: 'Type',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: Helper.textsHelper().getPaymentProcessName(PaymentProcessesEnum.All),
                            value: PaymentProcessesEnum.All
                        },
                        {
                            label: Helper.textsHelper().getPaymentProcessName(PaymentProcessesEnum.Funding),
                            value: PaymentProcessesEnum.Funding
                        },
                        {
                            label: Helper.textsHelper().getPaymentProcessName(PaymentProcessesEnum.Withdrawal),
                            value: PaymentProcessesEnum.Withdrawal,
                        },
                        {
                            label: Helper.textsHelper().getPaymentProcessName(PaymentProcessesEnum.Transfer),
                            value: PaymentProcessesEnum.Transfer,
                        },
                        {
                            label: Helper.textsHelper().getPaymentProcessName(PaymentProcessesEnum.Adjustment),
                            value: PaymentProcessesEnum.Adjustment,
                        },
                        {
                            label: Helper.textsHelper().getPaymentProcessName(PaymentProcessesEnum.Purchase),
                            value: PaymentProcessesEnum.Purchase,
                        }
                    ]
                })
            ],
            sortIndex: 2
        },
        {
            name: PaymentFilterModel.getPaymentMethodSelector(),
            placeholder: 'Method',
            controls: [
                new SelectControl({
                    name: PaymentFilterModel.getPaymentMethodSelector(),
                    value: PaymentMethodsEnum.All,
                    placeholder: 'Method',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: Helper.textsHelper().getPaymentMethodName(PaymentMethodsEnum.All),
                            value: PaymentMethodsEnum.All
                        },
                        {
                            label: Helper.textsHelper().getPaymentMethodName(PaymentMethodsEnum.BankTransfer),
                            value: PaymentMethodsEnum.BankTransfer
                        },
                        {
                            label: Helper.textsHelper().getPaymentMethodName(PaymentMethodsEnum.eWallet),
                            value: PaymentMethodsEnum.eWallet
                        },
                        {
                            label: Helper.textsHelper().getPaymentMethodName(PaymentMethodsEnum.Card),
                            value: PaymentMethodsEnum.Card
                        },
                        {
                            label: Helper.textsHelper().getPaymentMethodName(PaymentMethodsEnum.InternalTransfer),
                            value: PaymentMethodsEnum.InternalTransfer
                        },
                        {
                            label: Helper.textsHelper().getPaymentMethodName(PaymentMethodsEnum.Adjustment),
                            value: PaymentMethodsEnum.Adjustment
                        },
                        {
                            label: Helper.textsHelper().getPaymentMethodName(PaymentMethodsEnum.Crypto),
                            value: PaymentMethodsEnum.Crypto
                        }
                    ]
                })
            ],
            sortIndex: 3
        },
        {
            name: PaymentFilterModel.getAccountOwnerNameSelector(),
            placeholder: 'Customer',
            controls: [
                new BaseControl({
                    name: PaymentFilterModel.getAccountOwnerNameSelector(),
                    value: null,
                    placeholder: 'Customer',
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                })
            ],
            sortIndex: 4

        },
        {
            name: PaymentFilterModel.getAccountReferenceIdSelector(),
            placeholder: 'Account',
            controls: [
                new BaseControl({
                    name: PaymentFilterModel.getAccountReferenceIdSelector(),
                    value: null,
                    placeholder: 'Account',
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                })
            ],
            sortIndex: 5
        },
        {
            name: PanelPaymentsFilterAmountSelector,
            placeholder: 'Amount',
            controls: [
                new AmountControl({
                    name: PaymentFilterModel.getAmountFromSelector(),
                    value: null,
                    placeholder: 'Amount From',
                    validators: [],
                    componentType: ComponentTypesEnum.AmountInput,
                    currency: null,
                    sortIndex: 1
                }),
                new AmountControl({
                    name: PaymentFilterModel.getAmountToSelector(),
                    value: null,
                    placeholder: 'Amount To',
                    validators: [],
                    componentType: ComponentTypesEnum.AmountInput,
                    currency: null,
                    sortIndex: 2
                }),
            ],
            sortIndex: 6
        },
        {
            name: PanelPaymentsFilterDateSelector,
            placeholder: 'Date',
            controls: [
                new DatepickerControl({
                    name: PaymentFilterModel.getDateFromSelector(),
                    value: null,
                    placeholder: 'Date From',
                    maxDate: moment().format('YYYY-MM-DD'),
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 1
                }),
                new DatepickerControl({
                    name: PaymentFilterModel.getDateToSelector(),
                    value: null,
                    placeholder: 'Date To',
                    maxDate: moment().format('YYYY-MM-DD'),
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 2
                }),
            ],
            sortIndex: 7
        },
        {
            name: PanelPaymentsFilterSettledDateSelector,
            placeholder: 'Settled Date',
            controls: [
                new DatepickerControl({
                    name: PaymentFilterModel.getSettledDateFromSelector(),
                    value: null,
                    placeholder: 'Settled From',
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 1
                }),
                new DatepickerControl({
                    name: PaymentFilterModel.getSettledDateToSelector(),
                    value: null,
                    placeholder: 'Settled To',
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 2
                }),
            ],
            sortIndex: 8
        },
        {
            name: PaymentFilterModel.getCreatedBySelector(),
            placeholder: 'Created By',
            controls: [
                new BaseControl({
                    name: PaymentFilterModel.getCreatedBySelector(),
                    value: null,
                    placeholder: 'Created By',
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                })
            ],
            sortIndex: 9
        },
        {
            name: PaymentFilterModel.getCurrencySelector(),
            placeholder: 'Currency',
            controls: [
                new SelectControl({
                    name: PaymentFilterModel.getCurrencySelector(),
                    value: null,
                    placeholder: 'Currency',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: []
                }),
            ],
            sortIndex: 10,
        },
        {
            name: PaymentFilterModel.getCategorySelector(),
            placeholder: 'Category',
            controls: [
                new SelectControl({
                    name: PaymentFilterModel.getCategorySelector(),
                    value: null,
                    placeholder: 'Category',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    multiple :true,
                    options: [
                        {
                            label: Helper.textsHelper().getAdjustmentCategoryName(AdjustmentCategoryEnum.StockLocate),
                            value: AdjustmentCategoryEnum.StockLocate
                        },
                        {
                            label: Helper.textsHelper().getAdjustmentCategoryName(AdjustmentCategoryEnum.Software),
                            value: AdjustmentCategoryEnum.Software
                        },
                        {
                            label: Helper.textsHelper().getAdjustmentCategoryName(AdjustmentCategoryEnum.ShortMarginInterest),
                            value: AdjustmentCategoryEnum.ShortMarginInterest
                        },
                        {
                            label: Helper.textsHelper().getAdjustmentCategoryName(AdjustmentCategoryEnum.Platform),
                            value: AdjustmentCategoryEnum.Platform
                        },
                        {
                            label: Helper.textsHelper().getAdjustmentCategoryName(AdjustmentCategoryEnum.PNL),
                            value: AdjustmentCategoryEnum.PNL
                        },
                        {
                            label: Helper.textsHelper().getAdjustmentCategoryName(AdjustmentCategoryEnum.OvernightBorrow),
                            value: AdjustmentCategoryEnum.OvernightBorrow
                        },
                        {
                            label: Helper.textsHelper().getAdjustmentCategoryName(AdjustmentCategoryEnum.Miscellaneous),
                            value: AdjustmentCategoryEnum.Miscellaneous
                        },
                        {
                            label: Helper.textsHelper().getAdjustmentCategoryName(AdjustmentCategoryEnum.MarketData),
                            value: AdjustmentCategoryEnum.MarketData
                        },
                        {
                            label: Helper.textsHelper().getAdjustmentCategoryName(AdjustmentCategoryEnum.Invoice),
                            value: AdjustmentCategoryEnum.Invoice
                        },
                        {
                            label: Helper.textsHelper().getAdjustmentCategoryName(AdjustmentCategoryEnum.Dividend),
                            value: AdjustmentCategoryEnum.Dividend
                        },
                        {
                            label: Helper.textsHelper().getAdjustmentCategoryName(AdjustmentCategoryEnum.eSignal),
                            value: AdjustmentCategoryEnum.eSignal
                        },
                        {
                            label: Helper.textsHelper().getAdjustmentCategoryName(AdjustmentCategoryEnum.Bundle),
                            value: AdjustmentCategoryEnum.Bundle
                        },
                        {
                            label: Helper.textsHelper().getAdjustmentCategoryName(AdjustmentCategoryEnum.Rebate),
                            value: AdjustmentCategoryEnum.Rebate
                        },
                        {
                            label: Helper.textsHelper().getAdjustmentCategoryName(AdjustmentCategoryEnum.DailyInterest),
                            value: AdjustmentCategoryEnum.DailyInterest
                        },
                        {
                            label: Helper.textsHelper().getAdjustmentCategoryName(AdjustmentCategoryEnum.DailyFreeCashInterest),
                            value: AdjustmentCategoryEnum.DailyFreeCashInterest
                        }
                    ]
                }),
            ],
            sortIndex: 11,
        },
    ];
    if (Helper.isFeatureEnabled(FeatureEnum.TradingPlans)){
        const planFilters = [
            {
                name: PaymentFilterModel.getPurchaseTypeIdsSelector(),
                placeholder: 'Charge SubType',
                controls: [
                    new SelectControl({
                        name: PaymentFilterModel.getPurchaseTypeIdsSelector(),
                        value: PaymentPurchaseTypeEnum.All,
                        placeholder: 'Charge SubType',
                        validators: [],
                        componentType: ComponentTypesEnum.Select,
                        options: [
                            {
                                label: Helper.textsHelper().getPurchaseTypeName(PaymentPurchaseTypeEnum.All),
                                value: PaymentPurchaseTypeEnum.All
                            },
                            {
                                label: Helper.textsHelper().getPurchaseTypeName(PaymentPurchaseTypeEnum.Plan),
                                value: PaymentPurchaseTypeEnum.Plan
                            },
                            {
                                label: Helper.textsHelper().getPurchaseTypeName(PaymentPurchaseTypeEnum.AccountExpiryExtension),
                                value: PaymentPurchaseTypeEnum.AccountExpiryExtension,
                            },
                            {
                                label: Helper.textsHelper().getPurchaseTypeName(PaymentPurchaseTypeEnum.AccountDailyLossRewind),
                                value: PaymentPurchaseTypeEnum.AccountDailyLossRewind,
                            },
                            {
                                label: Helper.textsHelper().getPurchaseTypeName(PaymentPurchaseTypeEnum.AutoPass),
                                value: PaymentPurchaseTypeEnum.AutoPass,
                            },
                            {
                                label: Helper.textsHelper().getPurchaseTypeName(PaymentPurchaseTypeEnum.PlanWithAutoPass),
                                value: PaymentPurchaseTypeEnum.PlanWithAutoPass,
                            }
                        ]
                    })
                ],
                sortIndex: 12
            },
            {
                name: PaymentFilterModel.getTradingPlanReferenceIdSelector(),
                placeholder: 'Trading Plan Reference Id',
                controls: [
                    new BaseControl({
                        name: PaymentFilterModel.getTradingPlanReferenceIdSelector(),
                        value: null,
                        placeholder: 'Trading Plan Reference Id',
                        validators: [],
                        componentType: ComponentTypesEnum.Text
                    })
                ],
                sortIndex: 4

            },
        ];
        controls.push(...planFilters);
    }

    return controls;
};

export const PanelPaymentsDataTableItems = (): ReportTableData[] => {
    const items = [];
    items.push(new ReportTableData<string>({
            colId: PaymentReportModel.getPaymentStatusSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: PaymentReportModel.getAccountOwnerNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: PaymentReportModel.getAccountReferenceIdSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: PaymentReportModel.getPaymentProcessSelector(),
            value: null,
            hidden: false
        }));
    if (Helper.isFeatureEnabled(FeatureEnum.TradingPlans)){
        items.push(new ReportTableData<string>({
            colId: PaymentReportModel.getPurchaseTypeIdSelector(),
            value: null,
            hidden: false
        }));
    }
    items.push(
        new ReportTableData<string>({
            colId: PaymentReportModel.getPaymentMethodSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: PaymentReportModel.getAmountSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: PaymentReportModel.getCurrenyCodeSelector(),
            value: null,
            hidden: false
        }),

        new ReportTableData<string>({
            colId: PaymentReportModel.getDateSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: PaymentReportModel.getSettledDateSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: PaymentReportModel.getCreatedBySelector(),
            value: null,
            hidden: false
        }));

    return items;
};

export const PanelPaymentsDataTableConfig = (): ReportTableConfigInterface => {
    const columns = [
        new ReportTableColumn({
            label: 'Status',
            selector: PaymentReportModel.getPaymentStatusSelector(),
            sortable: true
        }),
        new ReportTableColumn({
            label: 'Customer',
            selector: PaymentReportModel.getAccountOwnerNameSelector(),
            sortable: true
        }),
        new ReportTableColumn({
            label: 'Account',
            selector: PaymentReportModel.getAccountReferenceIdSelector(),
            sortable: true
        }),
        new ReportTableColumn({
            label: 'Type',
            selector: PaymentReportModel.getPaymentProcessSelector(),
            sortable: true
        })
    ];
    if (Helper.isFeatureEnabled(FeatureEnum.TradingPlans)) {
        columns.push(new ReportTableColumn({
            label: 'SubType',
            selector: PaymentReportModel.getPurchaseTypeIdSelector(),
            sortable: true
        }));
    }
    columns.push(
        new ReportTableColumn({
            label: 'Method',
            selector: PaymentReportModel.getPaymentMethodSelector(),
            sortable: true
        }),
        new ReportTableColumn({
            label: 'Amount',
            selector: PaymentReportModel.getAmountSelector(),
            sortable: true
        }),
        new ReportTableColumn({
            label: 'Currency',
            selector: PaymentReportModel.getCurrenyCodeSelector(),
            sortable: true
        }),
        new ReportTableColumn({
            label: 'Date',
            selector: PaymentReportModel.getDateSelector(),
            sortable: true
        }),
        new ReportTableColumn({
            label: 'Settled',
            selector: PaymentReportModel.getSettledDateSelector(),
            sortable: true
        }),
        new ReportTableColumn({
            label: 'Created By',
            selector: PaymentReportModel.getCreatedBySelector(),
            sortable: true
        })
    );

    return {
        rows: [],
        columns,
        hiddenColumnIds: [],
        actionMenu: false
    };
};

export const BulkPaymentStatusChangeDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm,
                customText: 'Bulk Update'
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false
    };
};
